import { i18n } from '@lingui/core'
import { Button } from '@mui/material'

export type DownloadArtworkProps = {
  artworkFiles: ({ file_name: string; file_url: string; id: string } | null)[]
  color?: 'gold' | 'grey' | 'white' | 'blue' | 'blank' | undefined
  label?: string
  defaultStyle: boolean
}

export default function DownloadArtwork(props: DownloadArtworkProps) {
  const { artworkFiles, defaultStyle, color, label } = props
  const handleDownloadArtworkFiles = () => {
    artworkFiles?.forEach((artwork) => {
      const link = document.createElement('a')
      link.href = artwork?.file_url ?? ''
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  }
  return (
    <div>
      {!defaultStyle && (
        <div className='mb-1 flex items-center justify-center lg:mb-3'>
          {/* <Button
            type='button'
            color={color ?? 'white'}
            label={i18n._('My original artwork')}
            onClick={handleDownloadArtworkFiles}
            className='Type-Base-Medium w-full py-1'
          /> */}
          <Button
            variant='outlined'
            color='primary'
            size='small'
            className='w-full rounded-[5px] bg-pure-white uppercase'
            onClick={handleDownloadArtworkFiles}
          >
            {i18n._('Artwork')}
          </Button>
        </div>
      )}
      {defaultStyle && (
        <Button
          variant='outlined'
          color='primary'
          size='small'
          className='w-auto rounded-[5px] bg-pure-white uppercase'
          onClick={handleDownloadArtworkFiles}
        >
          {i18n._('My original artwork')}
        </Button>
      )}
    </div>
  )
}
